<ng-container *ngIf="locations$ | async; let locations">
    {{ locations[locationId]?.name }}
</ng-container>
